<div class="as-modal-container">
    <p>{{ 'PURCHASE.sure1' | translate }}</p>
    <div class="btn-container">
        <button mat-stroked-button color="accent" (click)="closeModal(false)">{{ 'STORES.cancel' | translate }}</button>
        <button mat-flat-button color="accent" (click)="closeModal(true)">{{ 'STORES.accept' | translate }}</button>
    </div>
</div>